import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { DnGhostBtnComponent } from './dn-ghost-btn.component';

@NgModule({
  declarations: [DnGhostBtnComponent],
  imports: [CommonModule, MatButtonModule],
  exports: [DnGhostBtnComponent],
})
export class DnGhostBtnModule {}
